import React from 'react'
import { FaCarCrash } from "react-icons/fa";
import { GoIssueClosed } from "react-icons/go";
import { IoIosStar } from "react-icons/io";
import { RiCustomerService2Fill } from "react-icons/ri";

const Stats = () => {
  return (
    <div>
       <div
    className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-y-5 lg:gap-y-0 gap-x-5 place-items-center w-full mx-auto max-w-7xl px-5 pb-8">
    <div
      className="flex flex-col justify-center items-center bg-[#FFF6F3] px-4 h-[126px] w-[100%] md:w-[281px] md:h-[192px] rounded-lg justify-self-center">
      <div className="flex flex-row justify-center items-center">
        <RiCustomerService2Fill size={42} color='#FF6042'/>
        <p className="font-bold text-3xl sm:text-4xl lg:text-5xl leading-9 text-primary ml-2">75K+</p>
      </div>
      <p className="font-medium text-base sm:text-lg leading-6 mt-3 md:mt-6 text-center">Expert Chat &amp; Call Minutes</p>
    </div>
    <div
      className="flex flex-col justify-center items-center bg-[#FFF6F3] px-4 h-[126px] w-[100%] md:w-[281px] md:h-[192px] rounded-lg justify-self-center">
      <div className="flex flex-row justify-center items-center">
        <IoIosStar size={42} color='#FF6042' />
        <p className="font-bold text-3xl sm:text-4xl lg:text-5xl leading-9 text-primary ml-2">4.9</p>
      </div>
      <p className="font-medium text-base sm:text-lg leading-6 mt-3 md:mt-6 text-center">Average Expert Rating</p>
    </div>
    <div
      className="flex flex-col justify-center items-center bg-[#FFF6F3] px-4 h-[126px] w-[100%] md:w-[281px] md:h-[192px] rounded-lg justify-self-center">
      <div className="flex flex-row justify-center items-center">
        <GoIssueClosed size={42} color='#FF6042' />
        <p className="font-bold text-3xl sm:text-4xl lg:text-5xl leading-9 text-primary ml-2">999+</p>
      </div>
      <p className="font-medium text-base sm:text-lg leading-6 mt-3 md:mt-6 text-center">Insurance Issued</p>
    </div>
    <div
      className="flex flex-col justify-center items-center bg-[#FFF6F3] px-4 h-[126px] w-[100%] md:w-[281px] md:h-[192px] rounded-lg justify-self-center">
      <div className="flex flex-row justify-center items-center">
        <FaCarCrash size={42} color='#FF6D42'/>
        <p className="font-bold text-3xl sm:text-4xl lg:text-5xl leading-9 text-primary ml-2">150</p>
      </div>
      <p className="font-medium text-base sm:text-lg leading-6 mt-3 md:mt-6 text-center">Claims</p>
    </div>
  </div>
    </div>
  )
}

export default Stats
